import { useMemo } from "react";
interface CategoryBannerProps {
  className?: string;
}
const ShopBanner: React.FC<CategoryBannerProps> = ({
  className = "mb-6 mt-2"
}) => {
  const videoSrc = useMemo(() => "/assets/images/video/aloe_bottles.mp4", []);
  return <div className={`relative flex justify-center items-center ${className} w-full max-w-full h-64 sm:h-[600px] rounded-3xl`} data-sentry-component="ShopBanner" data-sentry-source-file="shop-banner.tsx">
      <div className="absolute inset-0 bg-yellow-600 rounded-3xl blur-xl opacity-70 z-0" />
      <video autoPlay loop muted playsInline preload="none" controls={false} className="relative z-10 rounded-3xl w-full h-full object-cover">
        <source src={videoSrc} type="video/mp4" />
      </video>
    </div>;
};
export default ShopBanner;